module.exports = __webpack_public_path__ + "img/server-dark.5246c0cd.svg";